import styled from 'styled-components';

// Header
export const Header = styled.header`
  width: 100%;
  max-width: 768px;
  padding: 12px 20px;

  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const HeaderIcons = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const NotificationIconWrapper = styled.div<{ isNotificationRemind: boolean }>`
  svg {
    path:last-child {
      fill: ${({ isNotificationRemind, theme }) => (isNotificationRemind ? theme['orange-primary'] : 'inherit')};
    }
  }
`;
